import { useContext, useEffect, useState } from 'react'
import { YearContext } from '../../../contexts/YearContext'

import styles from './YearPicker.module.scss'
import { DatesSearchContext, DatesSearchContextType } from '../../../contexts/DatesSearchContext'

import Image from "next/image";

type YearPickerProps = {
  years: (string | string[] | undefined)[],
  name: string,
  onDatesChange?: (dates: string) => void,
}

export function YearPicker({ years, name, onDatesChange }: YearPickerProps) {
  const { year, setYear } = useContext(YearContext)
  const [dates, setDates] = useState('')
  const { datesSearch } = useContext<DatesSearchContextType>(DatesSearchContext);

  // If there's a hotel stay added, set park ticket year to match
  useEffect(() => {
    if (datesSearch[0] !== undefined) {
      const travelYear:string = datesSearch[0].getFullYear().toString();
      if (travelYear !== '' && setYear) setYear(travelYear);
    }
    const currentYear: string = new Date().getFullYear().toString()
    if (currentYear !== '' && setYear) setYear(currentYear);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datesSearch]);

  // No need to show a year picker if only one year is on sale:
  if (years.length < 2) return null

  const dates26 = ['1 Jan - 19 Oct', '20 Oct - 31 Dec']
  const dates27 = ['1 Jan - 31 Mar', '1 Apr - 31 Dec']

  const handleYearChange = (selectedYear: string) => {
    setYear && setYear(selectedYear)
    if (selectedYear === '2026') {
      setDates(dates26[0])
      onDatesChange?.(dates26[0])
    } else if (selectedYear === '2027') {
      setDates(dates27[0])
      onDatesChange?.(dates27[0])
    }
  }

  const handleDateChange = (selectedDate: string) => {
    setDates(selectedDate)
    onDatesChange?.(selectedDate)
  }

  const yearOptions = years.map(value => {
    const id = name + '-' + value
    const checked = value === year
    return (
      <span key={id}>
        <input id={id} type='radio' onChange={ ev => handleYearChange(ev.target.value) } name={name} value={value} checked={checked} className={styles.yearInput} />
        <label htmlFor={id} className={styles.yearLabel}>{ value }</label>
      </span>
    )
  })

  const dates26Options = dates26.map(date => {
    const checked = date === dates
    return (
      <span key={date} className={styles.dateWrapper}>
        <input id={date} type='radio' onChange={ ev => handleDateChange(ev.target.value) } value={date} checked={checked} className={styles.dateInput} />
        <label htmlFor={date} className={styles.dateLabel}>
          <Image
            src={checked ? "/calendar-images/calendar_white.svg" : "/calendar-images/calendar_blue.svg"}
            alt="calendar"
            width={24}
            height={24}
          />
          { date }
        </label>
      </span>
    )
  })

  const dates27Options = dates27.map(date => {
    const checked = date === dates
    return (
      <span key={date} className={styles.dateWrapper}>
        <input id={date} type='radio' onChange={ ev => handleDateChange(ev.target.value) } value={date} checked={checked} className={styles.dateInput} />
        <label htmlFor={date} className={styles.dateLabel}>
          <Image
            src={checked ? "/calendar-images/calendar_white.svg" : "/calendar-images/calendar_blue.svg"}
            alt="calendar"
            width={24}
            height={24}
          />
          { date }
        </label>
      </span>
    )
  })

  return (
    <div className={styles.YearPicker}>
      When are you going?
      <div className={styles.yearOptions}>
        {yearOptions}
      </div>
      <div>
        {year === '2026' && dates26Options}
        {year === '2027' && dates27Options}
      </div>
    </div>
  )
}
